import { useSelector } from 'react-redux';
import { useProductDetailContext } from '../containers/product/ProductDetailV2Container';
import { makeGetExpertReviews, makeGetProductReview } from '../redux/product/selectors/ProductSelector';
import { ProductDetailTabTypes } from '@as-react/common-types';
export const useProductDetailReviewCount = () => {
    const { tabs: productDetailTabs } = useProductDetailContext();
    const reviewTab = productDetailTabs === null || productDetailTabs === void 0 ? void 0 : productDetailTabs.find(tab => tab.type === ProductDetailTabTypes.REVIEWS);
    const userReview = useSelector(makeGetProductReview());
    const userReviewCount = (reviewTab === null || reviewTab === void 0 ? void 0 : reviewTab.showEndUserReview) && (userReview === null || userReview === void 0 ? void 0 : userReview.numberOfScores) ? Number(userReview.numberOfScores) : 0;
    const expertReviewCount = useSelector(makeGetExpertReviews()).length;
    const totalReviewCount = expertReviewCount + userReviewCount;
    return {
        totalReviewCount,
        expertReviewCount,
        userReviewCount,
    };
};
